import React from 'react'
import { useTranslation } from 'react-i18next'
import InputField from '../../../../../../components/formFields/InputField'
import SectionCard from '../shared/SectionCard'
import './style.css'
import DropDown from '@/components/formFields/DropDown'
import { LoadListDefault, useGet } from '@/api/hooks'
import { GetGovernmentAreaLookup, GetGovernmentLookup } from '@/api/endpoints'
import { IsListNotEmpty } from '@/utils'
import TextArea from '@/components/formFields/TextArea'
import ImgProfile from './ImgProfile'

const EditBasicInformation = ({ formHandler, providerInfo, isLoading }) => {
    const { t } = useTranslation()

    const { formValues } = formHandler



    return (
        <SectionCard
            title={t("basic-information")}
            icon="icon-park-twotone:me"
            className="edit-basic-info"
        >
            <div className="row">
                <div className="col-lg-12">

                    <ImgProfile providerInfo={providerInfo} formHandler={formHandler} />
                </div>
                <InputField
                    isLoading={isLoading}
                    className="col-lg-6"
                    formHandler={formHandler}
                    name={"providerName"}
                    defaultValue={providerInfo?.providerName}
                />
                <InputField
                    isLoading={isLoading}
                    className="col-lg-6"
                    formHandler={formHandler}
                    name={"providerNameEN"}
                    defaultValue={providerInfo?.providerNameEN || providerInfo?.providerName}
                    lang="En"
                />

                <InputField
                    isLoading={isLoading}
                    className="col-lg-6"
                    formHandler={formHandler}
                    name={"mainAddress"}
                    defaultValue={providerInfo?.mainAddress}
                />
                <InputField
                    isLoading={isLoading}
                    className="col-lg-6"
                    formHandler={formHandler}
                    name={"mainAddressEN"}
                    defaultValue={providerInfo?.mainAddressEN || providerInfo?.mainAddress}
                    lang="En"
                />

                <InputField
                    formHandler={formHandler}
                    name={"videoUrl"}
                    className="col-lg-12"
                    isLoading={isLoading}
                    label={"any"}
                    type="url"
                    defaultValue={providerInfo?.videoUrl}
                    isRequired={false}
                />

                <DropDown
                    isLoading={isLoading}
                    className="col-lg-6"
                    label={"government"}
                    formHandler={formHandler}
                    name={"government"}
                    defaultValue={providerInfo?.govs}
                    endPoint={GetGovernmentLookup}
                />
                <DropDown
                    isLoading={isLoading}
                    className="col-lg-6"
                    label={"area"}
                    formHandler={formHandler}
                    endPoint={GetGovernmentAreaLookup}
                    defaultValue={providerInfo?.areas}
                    name={"area"}
                    isAllowedToFetch={IsListNotEmpty(formValues?.government?.value)}
                    params={["government"]}
                />
                <TextArea
                    isLoading={isLoading}
                    className="col-lg-6"
                    label={"description"}
                    name={"description"}
                    defaultValue={providerInfo?.description}
                    formHandler={formHandler}
                />
                <TextArea
                    isLoading={isLoading}
                    className="col-lg-6"
                    name={"descriptionEN"}
                    lang="En"
                    label={"descriptionEN"}
                    defaultValue={providerInfo?.descriptionEN}
                    formHandler={formHandler}
                />
            </div>
        </SectionCard>
    )
}

export default EditBasicInformation

